/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareRoundedLetterX = createReactComponent("outline", "square-rounded-letter-x", "IconSquareRoundedLetterX", [["path", { "d": "M10 8l4 8", "key": "svg-0" }], ["path", { "d": "M10 16l4 -8", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

export { IconSquareRoundedLetterX as default };
//# sourceMappingURL=IconSquareRoundedLetterX.mjs.map
